





define(['services/utils'], function(Utils) {
    'use strict';
    /**
     * Name of the default key to be used.
     * @type {String}
     */
    var generalKey = '*';
    var keys = {};

    function checkStringType(parameter, message) {
        if (!Utils.isString(parameter)) {
            throw new TypeError(message);
        }
    }

    return {
        /**
         * Sets key from the 'config' object in security configuration file.
         * @example
         *  security.setKey('keyValue');  // sets global key
         *  security.setKey('service/traffic', 'keyValue'); // sets key for traffic service
         *
         * @method setKey
         * @param {String} name Name of the key to be set
         * @param {String} [value] Value of the key
         */
        setKey: function(name, value) {
            if (arguments.length === 1) {
                value = name;
                name = generalKey;
            }
            if (!value) {
                return;
            }
            checkStringType(name, 'Module name needs to be of type string');
            checkStringType(value, 'API key needs to be of type string');
            keys[name] = value;
        },

        /**
         * Clears keys, this method is meant to be used internally and should not be exposed
         * @example
         *  security._clearKeys();
         *
         * @method _clearKeys
         */
        _clearKeys: function() {
            keys = {};
        },

        /**
         * Returns function to sets key from the 'config' object in security configuration file with predefined module
         * name.
         * @example
         *  var setKey = security.setKeyForName('service/traffic');
         *  setKey('keyValue'); // sets key for traffic service
         *
         * @method setKeyForName
         * @param {String} name Name of the module
         * @return {Function} function that sets key for given module
         */
        setKeyForName: function(name) {
            checkStringType(name, 'Module name needs to be of type string');
            return function(value) {
                checkStringType(value, 'API key needs to be of type string');
                keys[name] = value;
            };
        },

        /**
         * Gets key's value from the "config" object in security configuration file.
         * Returns key value associated with type of given service - if exists - or generalKey otherwise.
         * @example
         *  security.getKey(this); // when used within service context
         *  security.getKey("generalKey");  // when used in other context
         *
         * @method getKey
         * @param {String} name Module name means name of the key
         * @return {String}
         */
        getKey: function(name) {
            if (name) {
                checkStringType(name, 'Module name needs to be of type string');
            }
            return keys[name] || keys[generalKey] || null;
        }
    };
});



// WEBPACK FOOTER //
// ./security/apiKeySecurity.js